import { render, staticRenderFns } from "./BotWeddingEventSettingsCard.vue?vue&type=template&id=a510fa0c"
import script from "./BotWeddingEventSettingsCard.vue?vue&type=script&lang=ts"
export * from "./BotWeddingEventSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports